import { render, staticRenderFns } from "./TableBudget.vue?vue&type=template&id=56c9fbdc&scoped=true&"
import script from "./TableBudget.vue?vue&type=script&lang=js&"
export * from "./TableBudget.vue?vue&type=script&lang=js&"
import style0 from "./TableBudget.vue?vue&type=style&index=0&id=56c9fbdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c9fbdc",
  null
  
)

export default component.exports